import * as React from 'react';
import { Col, Row } from '@thd-olt-component-react/core-ui';
import * as CardUtils from '../../common/utils/cardUtils';
import './WelcomeCardFooter.scss';
import { getHostCURL } from '../../common/utils/cardUtils';

export const WelcomeCardFooter = () => {
  const isAdmin = CardUtils.getUserRole() === 'ADMIN';
  const learnMoreLink = isAdmin ? getHostCURL('/myaccount/proxtraprogramdetails') : getHostCURL('/c/pro_xtra');
  const linkText = isAdmin ? 'See Your Member Benefits' : 'Learn More About Pro Xtra';
  return (
    <Col nopadding>
      <Row className="invisible">
        <a
          className="WelcomeCardFooter__footerLink"
          href={learnMoreLink}
          rel=" noreferrer"
        >{linkText}
        </a>
      </Row>
    </Col>
  );
};
